import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRoute from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import { DATA_IS_LOADING, DATA_IS_LOADED } from 'reducers/loader/reducer'
import {
  FETCH_PEW_FORECAST_LIST,
  FAILED_FETCH_PEW_FORECAST_LIST,
  SUCCEEDED_FETCH_PEW_FORECAST_LIST,
  FETCH_HISTORICAL_DATA,
  SUCCESS_HISTORICAL_DATA,
  FAIL_HISTORICAL_DATA,
  FETCH_FORECAST_DATA,
  SUCCESS_FORECAST_DATA,
  FAIL_FORECAST_DATA,
  FETCH_VISIBILITY_DATA,
  SUCCEEDED_VISIBILITY_DATA,
  FAIL_VISIBILITY_DATA,
  LOG_MONITOR_ACTIVITY,
} from './reducer'

function* fetchPewForecastList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.ENVIRONMENT_PEW, action.payload),
    })

    if (response && !response.error) {
      yield put({
        type: SUCCEEDED_FETCH_PEW_FORECAST_LIST,
        payload: response,
      })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createWarningObj(response.message),
        })
      }

      yield put({
        type: FAILED_FETCH_PEW_FORECAST_LIST,
        error: response.errors,
      })
    }
  } catch (error) {
    yield put({ type: FAILED_FETCH_PEW_FORECAST_LIST, error: error.errors })
  }
}

function* fetchHistoricalData(action) {
  try {
    yield put({ type: DATA_IS_LOADING })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.ENVIRONMENT_HISTORICAL,
        action.payload,
      ),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_HISTORICAL_DATA, payload: response })
      yield put({ type: DATA_IS_LOADED })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createWarningObj(response.message),
        })
      }

      yield put({ type: FAIL_HISTORICAL_DATA })
    }
  } catch (error) {
    console.log('HISTORICAL DATA FAILED ', error)
  }
}

function* fetchPredictionData(action) {
  try {
    yield put({ type: DATA_IS_LOADING })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.ENVIRONMENT_FORECAST, action.payload),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_FORECAST_DATA, payload: response })
      yield put({ type: DATA_IS_LOADED })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createWarningObj(response.message),
        })
      }

      yield put({ type: FAIL_FORECAST_DATA })
    }
  } catch (error) {
    console.log('FORECAST DATA FAILED ', error)
  }
}

function* fetchVisibilityData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.ENVIRONMENT_FORECAST, action.payload),
    })

    if (response && !response.error) {
      yield put({ type: SUCCEEDED_VISIBILITY_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createWarningObj(response.message),
        })
      }

      yield put({ type: FAIL_VISIBILITY_DATA })
    }
  } catch (error) {
    console.log('VISIBILITY DATA FAILED ', error)
  }
}

function* logMonitorActivity({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'POST',
      partUrl: ApiRoute.USER_ANALYTICS,
      data: payload,
    })

    if (response && response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createWarningObj(response.message),
      })
    }
  } catch (error) {
    console.log('FAILED LOGGING ACTIVITY', error)
  }
}

function* environmentMonitorSaga() {
  yield takeLatest(FETCH_HISTORICAL_DATA, fetchHistoricalData)
  yield takeLatest(FETCH_FORECAST_DATA, fetchPredictionData)
  yield takeLatest(FETCH_PEW_FORECAST_LIST, fetchPewForecastList)
  yield takeLatest(FETCH_VISIBILITY_DATA, fetchVisibilityData)
  yield takeLatest(LOG_MONITOR_ACTIVITY, logMonitorActivity)
}

export default environmentMonitorSaga
